import React, { useEffect, useRef } from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Link } from "../../../../plugins/gatsby-plugin-atollon"
import useArticleQuery from "../../../hooks/use-article-query"
import useProjectQuery from "../../../hooks/use-project-query"
import ArticleCard from "../../cards/article"
import ProjectCard from "../../cards/project"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

const LatestBlock = ({ title, link, latestType, slug }) => {
  const elementRef = useRef(null)
  const { allDatoCmsArticle } = useArticleQuery()
  const { allDatoCmsProject } = useProjectQuery()
  let list = []
  if (latestType === "news") list = allDatoCmsArticle.nodes
  if (latestType === "projects") list = allDatoCmsProject.nodes

  useEffect(() => {
    const line = elementRef.current?.querySelectorAll(".line")

    ScrollTrigger.create({
      trigger: elementRef.current,
      start: "top bottom",
      onEnter: () => {
        line.forEach((el) => el.classList.add("is-inview"))
      },
    })

    return () => {
    }
  }, [slug])

  return (
    <section className="latest-block" ref={elementRef}>
      <div className="latest-block__inner">
        <div className="latest-block__title">
          <div className="line line--horizon center-left"></div>
          {title && <h2>{parse(title)}</h2>}
          {link?.length > 0 && (<Link
            className="btn btn--orange"
            to={link[0].link[0].externalLink ? link[0].link[0].externalLink : link[0].link[0].internalLink.permalink}
          >
            {link[0].title}
          </Link>)}
        </div>

        <div className="latest-block__wrapper">
          <div className="line line--vertical center-bottom"></div>
          <div className="line line--vertical center-top"></div>
          <div className="line line--horizon center-right"></div>
          {list?.length > 0 &&
            <div className="latest-block__items">
              {
                list?.slice(0, 3).map((el, i) => {
                  if (latestType === "projects") return <ProjectCard key={i} {...el} />
                  if (latestType === "news") return <ArticleCard key={i} {...el} />
                })
              }
            </div>
          }
        </div>
      </div>
    </section>
  )
}

export default LatestBlock

export const query = graphql`
  fragment LatestBlockProps on DatoCmsLatestBlock {
    ... on DatoCmsLatestBlock {
      id
      title
      link {
        ...LinkWithTitleProps
      }
      latestType
    }
  }
`
